"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationIn = void 0;
class IntegrationIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return IntegrationIn.attributeTypeMap;
    }
}
exports.IntegrationIn = IntegrationIn;
IntegrationIn.discriminator = undefined;
IntegrationIn.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=IntegrationIn.js.map